<!-- 员工业绩 -->

<template>
    <div class="achievement">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                        <!-- <div class="left change-type">
                            <span @click="nowType='month'">按月查询</span>
                            <span :class="nowType=='month'?'type-wrap':'type-wrap to-right'" @click="nowType=='month'?nowType='timeRange':nowType='month'">
                                <i @click.stop=""></i>
                            </span>
                            <span @click="nowType='timeRange'">按时间段</span>
                        </div> -->
                        <div class="left monthBox clearfix" v-if="nowType=='month'">
                            <div class="left" @click="cutMonth(0)">上一月</div>
                            <el-date-picker
                                class="left"
                                v-model="yearMonth"
                                :picker-options="pickerOptions0"
                                type="month"
                                @change="cutDataFn"
                                placeholder="选择月">
                            </el-date-picker>
                            <div class="left" @click="cutMonth(1)">下一月</div>
                        </div>
                        <div class="time-range-filter" v-if="nowType=='timeRange'">
                            <el-date-picker
                            v-model="startTime"
                            type="datetime"
                            class="dateTime"
                            default-time="00:00:00"
                            :picker-options="pickerOptionsForTimeRange"
                            placeholder="开始时间">
                            </el-date-picker>
                            <el-date-picker
                            v-model="endTime"
                            type="datetime"
                            class="dateTime"
                            default-time="23:59:59"
                            :picker-options="pickerOptionsForTimeRange"
                            placeholder="结束时间">
                            </el-date-picker>
                            <span class="quick-filter">
                                <span :class="nowSelFilter=='today'?'active':''" @click.stop="filter('today')">今日</span>
                                <span :class="nowSelFilter=='lastDay'?'active':''" @click.stop="filter('lastDay')">昨日</span>
                                <span :class="nowSelFilter=='week'?'active':''" @click.stop="filter('week')">本周</span>
                                <span :class="nowSelFilter=='lastWeek'?'active':''" @click.stop="filter('lastWeek')">上周</span>
                                <span :class="nowSelFilter=='month'?'active':''" @click.stop="filter('month')">本月</span>
                                <span :class="nowSelFilter=='lastMonth'?'active':''" @click.stop="filter('lastMonth')">上月</span>
                            </span>
                            <span class="types typesSearch" >
                                <span type="button" @click="searchConfirm">查询</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:8%;">工号</th>
                                <th style="width:13%;">姓名</th>
                                <th style="width:13%;">岗位</th>
                                <th style="width:14%;">总订单量</th>
                                <th style="width:14%;">销售目标(元)</th>
                                <th style="width:14%;">总营业额(元)</th>
                                <th style="width:10%;">推荐会员数</th>
                                <th style="width:14%;">提成金额(元)</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:achieveArr.length>pageSize}">
                                    <tr v-for="item in achieveArr" class="listTr">
                                        <td style="width:8%;" v-text="item.employeeCode"></td>
                                        <!-- <td style="width:13%;" ><span v-text="item.employeeName" class="achievement-name" @click="curPage=1;commissionDetail(item)"></span></td> -->
                                        <td style="width:13%;" ><span v-text="item.employeeName"></span></td>
                                        <td style="width:13%;" v-text="item.groupName"></td>
                                        <td style="width:14%;" v-text="item.orderCount"></td>
                                        <td style="width:14%;" v-text="item.target"></td>
                                        <td style="width:14%;" v-text="item.totalAmount" class="achievement-name" @click="openMoneyDetail(item)"></td>
                                        <td style="width:10%;" v-text="item.addMemberNumber"></td>
                                        <td style="width:14%;" v-text="item.totalCommission" class="achievement-name" @click="curPage=1;commissionDetail(item)"></td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="out-excel">
                    <div class="">
                        <span class="right excel" @click="excel">导出Excel</span>
                    </div>
                </div>
                <el-dialog
                    :title="'本月业绩  '+employeeInfo.employeeName"
                    :visible.sync="openLoss"
                    size="tiny">
                    <div  id="mobile-style">
                        <div class="lossTotal flex flex-align-center">
                            <span class="span1">总计</span><span class="span2 blue" v-text="employeeInfo.productCount"></span><span class="span3">件商品</span>
                            <span class="span1">合计</span><span class="span2 red">{{employeeInfo.totalAmount | toFixedNum}}</span>
                            <span class="span3">元</span>
                        </div>
                        <div>
                            <ul class="goodList">
                                <li class="clearfix">
                                    <span class="idx left color1">序号</span>
                                    <span class="data left color1">时间</span>
                                    <span class="name left color1">订单号</span>
                                    <span class="number left color1">提成金额</span>
                                </li>
                            </ul>
                        </div>
                        <div class="scrollBox">
                            <div class="scroll">
                                <div class="space1"></div>
                                <ul class="goodList">
                                    <!-- <li class="clearfix">
                                        <span class="idx left color1">序号</span>
                                        <span class="data left color1">时间</span>
                                        <span class="name left color1">订单号</span>
                                        <span class="number left color1">提成金额</span>
                                    </li> -->
                                    <li class="clearfix lis" v-for="(item,ind) in commissionOrder">
                                        <span class="idx left" v-text="ind+1"></span>
                                        <span class="data left">{{item.paymentTime | numberToAllDate('')}}</span>
                                        <span class="name left" v-text="item.code"></span>
                                        <span class="number left" >￥{{item.commission | toFixedNum}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <!-- 分页器 -->
                    <!-- <div class="pager flex flex-align-center" id="pager">
                        <div class="pagerCon clearfix">
                            <div class="pagerBtnBox right">
                                <div class="pagerBtn">
                                    <span class="prev flex flex-align-center flex-pack-center left" :class="{havePage:curPage>1}"><i class="el-icon-arrow-left" @click="curPageFn(2)"></i></span>
                                    <span class="curPageNumber flex flex-align-center flex-pack-center left">{{curPage}}</span>
                                    <span class="next flex flex-align-center flex-pack-center left" :class="{havePage:curPage<employeeInfo.totalPages}"><i class="el-icon-arrow-right" @click="curPageFn(1)"></i></span>
                                </div>
                            </div>
                            <div class="curPage flex flex-align-center right" v-text="'第'+curPage+'/'+((employeeInfo.totalPages==0)?'1':employeeInfo.totalPages)+'页'"></div>
                            <div class="totalPage flex flex-align-center right" v-text="'共' +employeeInfo.totalElements+ '条'"></div>
                        </div>
                    </div> -->
                </el-dialog>
                <!-- 营业额弹窗 -->
                <el-dialog
                    :title="'本月营业额 '+nowMoneyDetailName"
                    :visible.sync="moneyDetail"
                    size="tiny">
                    <div  id="mobile-style">
                        <div class="space1" style="width:100%;height:15px;"></div>
                        <div class="clearfix" style="text-align:center;">
                            <span class="idx left color1" style="width:50%;text-align:left;">分类名称</span>
                            <span class="data left color1" style="width:10%;text-align:center;">销售数量</span>
                            <span class="number left color1" style="width:20%;text-align:center;">销售金额</span>
                            <span class="number left color1" style="width:20%;text-align:center;">提成金额</span>
                        </div>
                        <div class="space1" style="width:100%;height:15px;"></div>
                        <div class="scrollBox">
                            <div class="scroll">                                    
                                <ul class="goodList">
                                    <li class="clearfix lis p" v-for="(item,ind) in moneyDetailData" @click="doShowChild(ind)">
                                        <span class="idx left" style="width:50%;text-align:left;" v-text="item.typeName"></span>
                                        <span class="data left" style="width:10%;text-align:center;">
                                            {{item.qty}}
                                            <el-tooltip v-if="item.data && item.diffQty" class="item" effect="dark" :content="`其中包含${item.typeName}一级分类下的商品销售数：${item.diffQty}`" placement="top">
                                                <span class="wen">?</span>
                                            </el-tooltip>
                                        </span>
                                        <span class="number left" style="width:20%;text-align:center;">
                                            ￥{{item.amount.toFixed(2)}}
                                            <el-tooltip v-if="item.data && item.diffAmount" class="item" effect="dark" :content="`其中包含${item.typeName}一级分类下的商品销售金额：${item.diffAmount.toFixed(2)}`" placement="top">
                                                <span class="wen">?</span>
                                            </el-tooltip>
                                        </span>
                                        <span class="number left" style="width:20%;text-align:center;">
                                            ￥{{item.commission.toFixed(2)}}
                                            <el-tooltip v-if="item.data && item.diffCommission" class="item" effect="dark" :content="`其中包含${item.typeName}一级分类下的提成金额：${item.diffCommission.toFixed(2)}`" placement="top">
                                                <span class="wen">?</span>
                                            </el-tooltip>
                                        </span>
                                        <!-- <div class="child" @click.stop="" v-if="showChildIndex==ind && item.data && Array.isArray(item.data) && item.data.length"> -->
                                        <div class="child" @click.stop="" v-if="item.data && Array.isArray(item.data) && item.data.length">
                                            <li class="clearfix lis" v-for="(cIt,cInd) in item.data">
                                                <span class="idx left" style="width:50%;text-align:left;">---{{cIt.typeName}}</span>
                                                <span class="data left" style="width:10%;text-align:center;">{{cIt.qty}}</span>
                                                <span class="number left" style="width:20%;text-align:center;" v-text="'￥'+cIt.amount.toFixed(2)"></span>
                                                <span class="number left" style="width:20%;text-align:center;" v-text="'￥'+cIt.commission.toFixed(2)"></span>
                                            </li>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </el-dialog>
            </div>
        </div>
        <table id="scrollBox" style="display:none"> 
        </table>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    export default{
        props: ['curStoreId','pageSize'],
        data () {
            return {
                nowSelFilter:"month",
                nowType:"timeRange",
                pickerOptions0: {
                    //时间禁用,今天以后的时间禁用。
                    disabledDate(time) {
                        return time.getTime() > Date.now() || time.getTime() < (new Date('2017,01,01')).getTime();
                    }
                },
                pickerOptionsForTimeRange:{
                   disabledDate(time) {
                    
                    //    let date = (new Date(time));
                    // //    let dateStr = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();
                    // //    let newDate = new Date(dateStr).getTime();
                    // //    let newDateForNextMonth = new Date(date.getFullYear(),(date.getMonth()+1),0).getTime();
                    // //    return time.getTime() < newDate || time.getTime() > newDateForNextMonth;
                    //     let curDate = (new Date()).getTime();
                    //     let three = 30 * 24 * 3600 * 1000;
                    //     let threeDays = curDate - three;
                    //     return time.getTime() > Date.now() || time.getTime() < threeDays;
                    } 
                },
                employeeInfo:{
                    employeeName:'',//姓名
                    productCount:'',//商品总数
                    totalAmount:'',//
                    totalElements:'',//
                    totalPages:''
                },//订单信息
                commissionOrder:[],//订单数组
                openLoss:false,//订单详情弹出框
                moneyDetail:false,//总营业额详情弹出框
                moneyDetailData:[],
                nowMoneyDetailName:"",
                yearMonth:'',//年月
                startTime:'',//按时间段查询的起始时间
                endTime:'',//按时间段查询的结束时间
                achieveArr: [],//员工信息数组
                num:['01','02','03','04','05','06','07','08','09','10','11','12'],//月份string
                curMonth:parseInt((new Date).getMonth()+1),//当前月份
                curPage:1,//当前页
                curSize:10,//每页条数
                curEmployeeId:'',//当前员工id
                showChildIndex:-1,
            }
        },
        watch:{
            nowType : function(val){
                this.achieveArr = [];
            }
        },
        methods: {
            filter(type){
                let timeRangeArr = [];
                this.nowSelFilter = type;
                switch (type) {
                    case "today":
                        // this.yearMonth = new Date().Format("yyyy-MM");
                        this.startTime = `${new Date().Format("yyyy/MM/dd")} 00:00:00`;
                        // let year = new Date().Format("yyyy");
                        // let month = new Date().Format("MM");
                        this.endTime =  `${new Date().Format("yyyy/MM/dd")} 23:59:59`;
                        this.getdata("timeRange");
                        break;
                    case "lastDay":
                        this.startTime = `${new Date().Format("yyyy/MM/dd")} 00:00:00`;
                        this.startTime = `${new Date(new Date(this.startTime).getTime() - 1000*60*60*24).Format("yyyy/MM/dd")} 00:00:00`;
                        this.endTime =  `${new Date().Format("yyyy/MM/dd")} 23:59:59`;
                        this.endTime = `${new Date(new Date(this.endTime).getTime() - 1000*60*60*24).Format("yyyy/MM/dd")} 23:59:59`;
                        this.getdata("timeRange");
                        break;
                    case "week":
                        timeRangeArr = this.$dateRange.getThisWeek();
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.getdata("timeRange");
                        break;
                    case "lastWeek":
                        timeRangeArr = this.$dateRange.getLastWeek();
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.getdata("timeRange");
                        break;
                    case "month":
                        timeRangeArr = this.$dateRange.getThisMonth();
                        console.log(timeRangeArr)
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.getdata("timeRange");
                        break;
                    case "lastMonth":
                        timeRangeArr = this.$dateRange.getLastMonth();
                        console.log(timeRangeArr)
                        this.startTime = `${timeRangeArr[0]} 00:00:00`;
                        this.endTime = `${timeRangeArr[1]} 23:59:59`;
                        this.getdata("timeRange");
                        break;
                    default:
                        break;
                }
            },
            // 搜索
            searchConfirm: function () {

                // 
                let timeStr = new Date(this.startTime).getTime() + "-" + new Date(this.endTime).getTime();
                let nowTime = new Date().getTime();
                console.log();
                if(!(this.$canClickSelect("achievement",timeStr,nowTime))){
                    this.$message({
                        message: '5秒内禁止重复查询相同数据',
                        customClass: 'error'
                    });
                    return;
                }
                // 


                if(this.startTime!=='' && this.endTime!==''){
                    if(new Date(this.startTime)>new Date(this.endTime)){
                        this.$message({
                            message: '结束时间不能比开始时间小',
                            customClass: 'error'
                        })
                        return;
                    }
                    if(this.nowType == "month"){
                        this.getdata("MONTH");
                    }else{
                        this.getdata(this.nowType);
                    }

                }else{
                    this.$message({
                        message: '请选择查询时间段',
                        customClass: 'error'
                    })
                    return;
                }
            },
            openMoneyDetail(item){
                
                if(!item.id){
                    return;
                }

                // console.log(item.id);
                
                this.nowMoneyDetailName = item.employeeName;

                let year = this.yearMonth.split('-')[0];
                let month = this.yearMonth.split('-')[1];

                // console.log("year:"+year,"month:"+month);
                let params;
                if(this.nowType == "month"){
                    params = {
                        year,
                        month,
                        storeId:this.curStoreId,
                        date:`${year}${month}`,
                        type:this.nowType=="month"?"MONTH":this.nowType,
                    }
                }else{
                   let from = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                   let to = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                   params = {
                        year,
                        month,
                        storeId:this.curStoreId,
                        date:`${year}${month}`,
                        type:this.nowType=="month"?"MONTH":this.nowType,
                        from,
                        to
                    } 
                }


                this.$http({
                    url:"/employees/"+item.id+"/sales-statics",
                    params
                }).then(res=>{
                    // 
                    let parentObj = {};
                    let formatRes = [];
                    if(res.data.items && Array.isArray(res.data.items) && res.data.items.length){
                        res.data.items.forEach(it=>{
                            if(it.parentTypeId && it.parentTypeId!="null"){
                                parentObj[it.parentTypeId] = {
                                    amount:0,
                                    commission:0,
                                    qty:0,
                                    typeName:"",
                                    data:[]
                                }
                            }else{
                                formatRes.push(it);
                            }
                        });
                        for(let k in parentObj){
                             res.data.items.forEach(it=>{
                                if(it.parentTypeId == k){
                                    parentObj[k].data.push(it);
                                    parentObj[k].amount += Number(it.amount);
                                    parentObj[k].commission += Number(it.commission);
                                    parentObj[k].qty += Number(it.qty);
                                }
                             })
                             if(parentObj[k].data && Array.isArray(parentObj[k].data) && parentObj[k].data.length){
                                parentObj[k].typeName = parentObj[k].data[0].parentTypeName;
                             }
                        }
                    }
                    // 
                    let formatData = [];
                    for(let k in parentObj){
                        let flag = false;
                        formatRes.forEach(it=>{
                            if(it.typeId == k){
                                flag = true;
                                if(parentObj[k].data && Array.isArray(parentObj[k].data) && parentObj[k].data.length){
                                    parentObj[k].data.sort((a,b)=>{
                                        return b.amount-a.amount
                                    })
                                }
                                
                                it["data"] = parentObj[k].data;
                                it["qty"] = Number(parentObj[k].qty) + Number(it["qty"]);
                                it["diffQty"] = it["qty"] - parentObj[k].qty;
                                it["amount"] = Number(parentObj[k].amount) + Number(it["amount"]);
                                it["diffAmount"] = it["amount"] - parentObj[k].amount;
                                it["commission"] = Number(parentObj[k].commission) + Number(it["commission"]);
                                it["diffCommission"] = it["commission"] - parentObj[k].commission;
                            }
                        })
                        if(!flag){
                            if(parentObj[k].data && Array.isArray(parentObj[k].data) && parentObj[k].data.length){
                                parentObj[k].data.sort((a,b)=>{
                                    return b.amount-a.amount
                                })
                            }
                            formatRes.push(parentObj[k]);
                        }
                    }
                    
                    // 
                    console.log(parentObj);
                    // formatRes = [...formatRes,...Object.values(parentObj)]
                    console.log(formatRes);
                    // 
                    if(formatRes && Array.isArray(formatRes) && formatRes.length){
                        formatRes.sort((a,b)=>{
                            return b.amount-a.amount;
                        })
                    }
                    
                    this.moneyDetailData = formatRes;
                    // this.moneyDetailData = res.data.items;
                    // console.log(res);
                });

                this.moneyDetail = true;
            },
            // 
            doShowChild(ind){
                if(this.showChildIndex == ind){
                    this.showChildIndex = -1;
                    return;
                }
                this.showChildIndex = ind;
            },
            //日历插件 
            cutDataFn(){
                // console.log(this.yearMonth)
                if(!this.yearMonth) {
                    this.curMonth = 'nan'
                    return ;
                }
                this.yearMonth = new Date(this.yearMonth).Format("yyyy-MM");
                this.curMonth = parseInt(this.yearMonth.split('-')[1]);
                this.getdata("MONTH");
            },
            //上月，下月按钮 
            cutMonth(foo){
                if(this.curMonth == 'nan'){
                    this.$message({
                        message: '请选择时间',
                        customClass: 'error'
                    })
                    return ;
                }
                this.yearMonth = new Date(this.yearMonth).Format("yyyy-MM");//给日期插件赋值为选择时间
                let year = this.yearMonth.split('-')[0];//选择的年
                let month = this.yearMonth.split('-')[1];//选则的月
                if(foo==0){
                    //上月
                    if(new Date('2017,01,01').Format("yyyy-MM")==new Date(this.yearMonth).Format("yyyy-MM")) {
                        this.$message({
                            message: '不能选择2017年以前的时间!',
                            customClass: 'error'
                        })
                        return;
                    }
                    this.curMonth --;
                    if(this.curMonth == 0) {
                        year = parseInt(year)-1;
                        this.curMonth = 12;
                    }
                }else if(foo==1){
                    //下月
                    if(new Date().Format("yyyy-MM")==new Date(this.yearMonth).Format("yyyy-MM")) {
                        this.$message({
                            message: '已经是最新一个月了！',
                            customClass: 'error'
                        })
                        return;
                    }
                    this.curMonth ++;
                    if(this.curMonth == 13) {
                        year = parseInt(year) + 1;
                        this.curMonth = 1;
                    }
                }
                this.yearMonth = year+'-'+this.num[parseInt(this.curMonth)-1];
            },
            curPageFn(foo){
                // console.log(this.curEmployeeId);
                if(this.employeeInfo.totalPages<=1){
                    return;
                }
                if(foo==2){
                    if( this.curPage==1 ){
                        return;
                    }
                    this.curPage --;
                }else if(foo==1) {
                    if( this.curPage==this.employeeInfo.totalPages ){
                        return;
                    }
                    this.curPage ++;
                }
                this.commissionDetail({id:this.curEmployeeId});
            },
            //员工订单详情
            commissionDetail(item){
                if(!item.id){
                    return;
                }
                console.log(item.id);
                console.log(item);
                this.commissionOrder = [];
                this.curEmployeeId = item?item.id:this.curEmployeeId;//有item就更换员工id，没有就不改变。
                if(this.nowType == "month"){
                    this.$http.get(
                        'employee-commission/'+this.curEmployeeId
                        +'?year='+this.yearMonth.split('-')[0]
                        +'&month='+this.yearMonth.split('-')[1]
                        +'&page='+(this.curPage-1)
                        +'&size='+this.curSize
                        +'&storeId='+this.curStoreId
                        +'&type=MONTH').then((res)=>{
                        this.openLoss = true;
                        this.commissionOrder = res.data;
                        this.employeeInfo = {
                            employeeName:item.employeeName,
                            productCount:item.qty,
                            totalAmount:item.totalCommission,
                            totalElements:res.data.totalElements,
                            totalPages:res.data.totalPages
                        }
                    })
                }else{
                    let from = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                    let to = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                   this.$http.get(
                        'employee-commission/'+this.curEmployeeId
                        +'?year='+this.yearMonth.split('-')[0]
                        +'&month='+this.yearMonth.split('-')[1]
                        +'&page='+(this.curPage-1)
                        +'&size='+this.curSize
                        +'&storeId='+this.curStoreId
                        +'&type=timeRange'
                        +'&from='+from
                        +'&to='+to).then((res)=>{
                        this.openLoss = true;
                        this.commissionOrder = res.data;
                        this.employeeInfo = {
                            employeeName:item.employeeName,
                            productCount:item.qty,
                            totalAmount:item.totalCommission,
                            totalElements:res.data.totalElements,
                            totalPages:res.data.totalPages
                        }
                    }) 
                }
                
            },
            //导出按钮
            excel(){
                let data;
                if ( !this.achieveArr.length ) {
                    this.$message({
                        message: '无数据可导出',
                        customClass: 'error'
                    })
                    return;
                }
                data = this.achieveArr;

                let html = '<tr>'+  
                                '<td style="font-size:18px">姓名</td>'+
                                '<td style="font-size:18px">总订单量</td>'+
                                '<td style="font-size:18px">总营业额</td>'+ 
                                '<td style="font-size:18px">推荐会员数</td>'+ 
                                '<td style="font-size:18px">提成金额</td>'+
                            '</tr>'
                        for(let i=0;i<data.length;i++){
                            html  +='<tr>'+
                                        '<td>'+data[i].employeeName+'</td>'+
                                        '<td>'+data[i].orderCount+'</td>'+ 
                                        '<td>'+data[i].totalAmount+'</td>'+ 
                                        '<td>'+data[i].addMemberNumber+'</td>'+ 
                                        '<td>'+data[i].totalCommission+'</td>'+ 
                                    '</tr>'
                        }
                document.getElementById('scrollBox').innerHTML = html;
                window.method5(scrollBox);
            },
            //获取员工业绩数据
            getdata(type){
                let params;
                if(type == "MONTH"){
                    params = {
                        storeId:this.curStoreId,
                        year:this.yearMonth.split('-')[0],
                        month:this.yearMonth.split('-')[1],
                        type
                    }
                }else{
                    let from = new Date(this.startTime).Format("yyyy-MM-dd hh:mm:ss");
                    let to = new Date(this.endTime).Format("yyyy-MM-dd hh:mm:ss");
                    params = {
                        storeId:this.curStoreId,
                        from,
                        to,
                        type
                    }
                }
                this.$http({
                    url:"employee-commission",
                    method:"GET",
                    params
                }).then(res=>{
                    for (let i = 0, len = res.data.length; i < len; i++) {
                        res.data[i].totalAmount = res.data[i].totalAmount.toFixed(2);
                    }
                    this.achieveArr = res.data;
                    let number = this.pageSize - this.achieveArr.length;
                    if ( number > 0 ) {
                        for (let i = 0; i < number; i++) {
                            this.achieveArr.push({
                                id: '', // 员工id
                                employeeName: '', // 员工姓名
                                employeeCode: '', // 编号
                                groupName: '', // 岗位名字
                                orderCount: '', // 总订单量
                                totalAmount: '', // 总营业额
                                totalCommission: '', // 提成金额
                            });
                        }
                    }
                });
                // this.$http.get('employee-commission?storeId='+this.curStoreId+'&year='+this.yearMonth.split('-')[0]+'&month='+this.yearMonth.split('-')[1]).then((res)=>{
                //     for (let i = 0, len = res.data.length; i < len; i++) {
                //         res.data[i].totalAmount = res.data[i].totalAmount.toFixed(2);
                //     }
                //     this.achieveArr = res.data;
                //     let number = this.pageSize - this.achieveArr.length;
                //     if ( number > 0 ) {
                //         for (let i = 0; i < number; i++) {
                //             this.achieveArr.push({
                //                 id: '', // 员工id
                //                 employeeName: '', // 员工姓名
                //                 employeeCode: '', // 编号
                //                 groupName: '', // 岗位名字
                //                 orderCount: '', // 总订单量
                //                 totalAmount: '', // 总营业额
                //                 totalCommission: '', // 提成金额
                //             });
                //         }
                //     }
                // })
            }
        },
        created(){
            for (let i = 0; i < this.pageSize; i++) {
                this.achieveArr.push({})
            }
            this.yearMonth = new Date().Format("yyyy-MM");
            this.startTime = `${new Date().Format("yyyy/MM")}/01 00:00:00`;
            let year = new Date().Format("yyyy");
            let month = new Date().Format("MM");
            this.endTime =  `${new Date(year,month,0).Format("yyyy/MM/dd")} 23:59:59`;
        },
        activated: function () {
            // this.getdata("MONTH");
            this.getdata("timeRange");
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    @import '../../tableTemplate/el-dialog.scss';
    @import "achievement";
</style>



// WEBPACK FOOTER //
// achievement.vue?f26ddb36